<app-page-title titleHeading='Cards examples 7' titleDescription='Wide selection of cards with multiple styles, borders, actions and hover effects.'></app-page-title>

<app-example-wrapper-seamless sectionHeading="Cards 42">
    <app-cards7-examples-42></app-cards7-examples-42>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 43">
    <app-cards7-examples-43></app-cards7-examples-43>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 44">
    <app-cards7-examples-44></app-cards7-examples-44>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 45">
    <app-cards7-examples-45></app-cards7-examples-45>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 46">
    <app-cards7-examples-46></app-cards7-examples-46>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 47">
    <app-cards7-examples-47></app-cards7-examples-47>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 48">
    <app-cards7-examples-48></app-cards7-examples-48>
</app-example-wrapper-seamless>

